<template>
  <div>
    <v-toolbar flat>
      <v-text-field
          v-model="search"
          hide-details
          class="mr-5"
          label="Search"
          style="max-width: 230px"
      />
      <v-spacer />
      <v-btn
          class="mr-3"
          color="primary"
          @click="$emit('add')"
      >
        + Add
      </v-btn>
    </v-toolbar>

    <v-divider />

    <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :search="search"
        :custom-filter="customFilter"
        fixed-header
        class="neris-units-table header-nowrap"
        no-data-text="No data available"
        no-results-text="No data available"
    >
      <template v-slot:item.type="{ item }">
        {{ item.type && unitTypesMap[item.type] ? unitTypesMap[item.type] : item.type }}
      </template>
      <template v-slot:item.dedicatedStaffing="{ item }">
        {{ item.dedicatedStaffing ? 'Yes' : 'No' }}
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="actions no-wrap text-right align-right">
          <v-icon
              color="grey darken-2 "
              class="mr-3"
              @click="$emit('edit', item)"
          >
            edit
          </v-icon>
          <v-icon
              class="mr-3"
              color="grey darken-2"
              @click="$emit('delete', item)"
          >
            delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import neris from '@/api/neris';
import unitTypes from '@/components/Neris/Units/unitTypes';

export default {
  name: 'UnitsTable',

  props: {
    station: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      search: null,
      headers: [
        {
          text: 'Unit Name',
          value: 'cadDesignation1',
        },
        {
          text: 'Alternate Unit Name',
          value: 'cadDesignation2',
        },
        {
          text: 'Type',
          value: 'type',
        },
        {
          text: 'Staffing',
          value: 'staffing',
        },
        {
          text: 'Dedicated Staffing',
          value: 'dedicatedStaffing',
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          width: '100px',
        },
      ],
    };
  },
  computed: {
    unitTypesMap() {
      const map = {};
      unitTypes.forEach((item) => {
        if (item.value) {
          map[item.value] = item.text;
        }
      });
      return map;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    customFilter(value, search, item) {
      return (
        item.cadDesignation1.toLowerCase().includes(search.toLowerCase())
          || item.cadDesignation2.toLowerCase().includes(search.toLowerCase())
      );
    },
    resetItems() {
      this.items = [];
      this.fetchData();
    },
    async fetchData() {
      try {
        this.loading = true;
        const response = await neris.getUnits(this.station.id);
        this.items = response.data;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" module>
.actions {
  width: 20%;
}
</style>
<style lang="scss">
.neris-units-table {
  .v-data-table__wrapper {
    height: calc(100vh - 450px);
  }
  thead {
    th {
      z-index: 1 !important;
    }
  }
}
</style>
